import { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { GlobalContext } from '../../../contexts/GlobalContext';

const hasValidStoredSession = () => {
  const storedToken = localStorage.getItem('token');
  const storedExpiration = Number.parseInt(
    localStorage.getItem('tokenExpiration'),
    10
  );

  return Boolean(
    storedToken
    && Number.isFinite(storedExpiration)
    && Date.now() < storedExpiration
  );
};

const HomeNewRouteGuard = () => {
  const { token } = useContext(GlobalContext);

  return token || hasValidStoredSession()
    ? <Outlet />
    : <Navigate to="/login" replace />;
};

export default HomeNewRouteGuard;
